import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { User } from "../types/user";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

// Tạo API service với createApi
export const userApi = createApi({
  reducerPath: "userApi",
    baseQuery: baseQueryWithReauth,
  // baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  tagTypes: ["user"],
  endpoints: (builder) => ({
    getAllUser: builder.query<User[], void>({
      query: () => "user/get-all-user",
      providesTags: (result?: User[]) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "user" as const, _id })),
              { type: "user", _id: "LIST" },
            ]
          : [{ type: "user", _id: "LIST" }],
    }),
    createOrUpdateUser: builder.mutation({
      query: (user) => ({
        url: "user/create-or-update",
        method: "POST",
        body: user,
      }),
      invalidatesTags: ["user"],
    }),
  }),
});

// Export hooks để sử dụng trong component
export const { useGetAllUserQuery, useCreateOrUpdateUserMutation } = userApi;
